import { render, staticRenderFns } from "./CollaborateComment.vue?vue&type=template&id=1b0a8fea"
import script from "./CollaborateComment.vue?vue&type=script&lang=js"
export * from "./CollaborateComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports